import { render, staticRenderFns } from "./quickSeibiList.vue?vue&type=template&id=40ef4856&"
import script from "./quickSeibiList.vue?vue&type=script&lang=ts&"
export * from "./quickSeibiList.vue?vue&type=script&lang=ts&"
import style0 from "./quickSeibiList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports